export const EMAIL_PATTERN =
  '^([a-z0-9+_-]+)(.[a-z0-9+_-]+)*@([a-z0-9-]+.)+[a-z]{2,6}$';
export const PASSWORD_PATTERN = '(?=.*[a-zA-Z0-9])(?=.*[!@#$%^&]).{6,}';
export const MOBILE_PATTERN = '^((\\+91-?)|0)?[0-9]{10}$';
